<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>
           
                   <v-col cols="12" sm="6">
                        <date-input 
                            v-model="form.boxDate"
                            :label="$t('delivery.dailyBox.labels.boxDate')"
                            :error="hasInputErrors('boxDate')"
                            :error-messages="getInputErrors('boxDate')"
                        />
                    </v-col>
    
 
                    <v-col cols="12" sm="6">
                        <v-text-field
                                
                                prepend-icon="track_changes"
                                name="shift"
                                v-model="form.shift"
                                :label="$t('delivery.dailyBox.labels.shift')"
                                :placeholder="$t('delivery.dailyBox.labels.shift')"
                                :error="hasInputErrors('shift')"
                                :error-messages="getInputErrors('shift')"
                                color="secondary"
                                
                        ></v-text-field>
                    </v-col>
    
 
                    <v-col cols="12" sm="6">
                        <list-combobox
                                
                                icon="table_rows"
                                name="rows"
                                v-model="form.rows"
                                :label="$t('delivery.dailyBox.labels.rows')"
                                :error="hasInputErrors('rows')"
                                :error-messages="getInputErrors('rows')"
                        ></list-combobox>
                    </v-col>
    
        </v-row>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule , ListCombobox} from '@dracul/common-frontend'
    
    
    
    import {DayjsMixin, DateInput} from "@dracul/dayjs-frontend";

    

    export default {
        name: "DailyBoxForm",
        mixins: [InputErrorsByProps, RequiredRule , DayjsMixin   ],
        components: {
          ListCombobox,
          DateInput
        },
        props:{
            value: {
                type: Object,
                required: true
            },
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
         watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            },
            save(){
              this.$emit('save', this.form)
            }
        },
        data(){
            return {
                boxDateDateMenu: false
            }
        }
    }
</script>

<style scoped>

</style>

